export const RightIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.4697 17.4697C20.7626 17.1768 21.2374 17.1768 21.5303 17.4697L26.8232 22.7626C26.8313 22.7706 26.8394 22.7788 26.8476 22.7869C26.9927 22.9319 27.1496 23.0887 27.2642 23.2388C27.3984 23.4148 27.5429 23.6665 27.5429 24C27.5429 24.3335 27.3984 24.5852 27.2642 24.7612C27.1496 24.9113 26.9927 25.0681 26.8476 25.2131C26.8394 25.2212 26.8313 25.2294 26.8232 25.2374L21.5303 30.5303C21.2374 30.8232 20.7626 30.8232 20.4697 30.5303C20.1768 30.2374 20.1768 29.7626 20.4697 29.4697L25.7626 24.1768C25.8326 24.1067 25.8894 24.0499 25.9377 24C25.8894 23.9501 25.8326 23.8933 25.7626 23.8232L20.4697 18.5303C20.1768 18.2374 20.1768 17.7626 20.4697 17.4697Z"
      fill="#18191B"
    />
  </svg>
);
